var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ffff",
      strokeWidth: 1.61484
    },
    d: "m 36.539124,93.470937 1.807745,156.691933 188.209111,-0.42355 0.003,-186.519133 z",
    id: "path77241"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ffff",
      strokeWidth: 1.61484
    },
    d: "m 38.683835,423.60481 0.943439,-156.69745 188.203506,0.64103 1.03258,186.52819 z",
    id: "path77241-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ffff",
      strokeWidth: 2.01438
    },
    d: "m 242.6284,461.9853 0.7336,-195.48105 234.76572,-1.94581 0.29784,180.21102 c 0,0 -4.49125,21.59676 -17.30026,32.30735 -17.99474,15.04679 -42.80094,11.42554 -42.80094,11.42554 z",
    id: "path77241-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00ffff",
      strokeWidth: 1.97601
    },
    d: "m 244.09181,58.6874 2.92985,190.60886 231.65628,-1.06026 0.38825,-171.705041 c 0,0 -0.0201,-19.492592 -20.19068,-32.166626 -23.26601,-14.619002 -46.353,-12.205453 -46.353,-12.205453 z",
    id: "path77241-7"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinicon);
export default __webpack_public_path__ + "static/media/winicon.e3bcd9eb2f7421b787804f9eb68331db.svg";
export { ForwardRef as ReactComponent };